import React, { useRef } from 'react';
import IconButton from '@material-ui/core/IconButton';

import a from 'src/assets/icons/a.svg'
import w from 'src/assets/icons/w.svg'
import s from 'src/assets/icons/s.svg'
import d from 'src/assets/icons/d.svg'
import leftArrow from 'src/assets/icons/leftArrow.svg'
import rightArrow from 'src/assets/icons/rightArrow.svg'
import upArrow from 'src/assets/icons/upArrow.svg'
import downArrow from 'src/assets/icons/downArrow.svg'
import isMobile from 'ismobilejs';

import { Box } from '@material-ui/core';
import { COLORS } from 'src/utils/cubiButtonUtils';

const gamepadSVG = `
<svg width="485" height="183" viewBox="0 0 485 183" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="path-1-inside-1_3234_25295" fill="white">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9596 182.251H206.326C211.751 176.245 216.507 169.684 220.486 162.671H264.515C268.493 169.684 273.249 176.245 278.675 182.251H457.041C474.476 162.949 485.001 137.915 485.001 110.562C485.001 49.5004 432.554 0 367.858 0C340.709 0 315.718 8.71657 295.853 23.3463H189.147C169.283 8.71657 144.291 0 117.143 0C52.4466 0 0 49.5004 0 110.562C0 137.915 10.5243 162.949 27.9596 182.251Z"/>
  </mask>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9596 182.251H206.326C211.751 176.245 216.507 169.684 220.486 162.671H264.515C268.493 169.684 273.249 176.245 278.675 182.251H457.041C474.476 162.949 485.001 137.915 485.001 110.562C485.001 49.5004 432.554 0 367.858 0C340.709 0 315.718 8.71657 295.853 23.3463H189.147C169.283 8.71657 144.291 0 117.143 0C52.4466 0 0 49.5004 0 110.562C0 137.915 10.5243 162.949 27.9596 182.251Z" fill="#E7E7E7"/>
  <path d="M27.9596 182.251L17.341 191.843L21.6023 196.56H27.9596V182.251ZM206.326 182.251V196.56H212.683L216.945 191.843L206.326 182.251ZM220.486 162.671V148.362H212.151L208.039 155.611L220.486 162.671ZM264.515 162.671L276.961 155.611L272.849 148.362H264.515V162.671ZM278.675 182.251L268.056 191.843L272.317 196.56H278.675V182.251ZM457.041 182.251V196.56H463.398L467.66 191.843L457.041 182.251ZM295.853 23.3463V37.6553H300.554L304.339 34.8678L295.853 23.3463ZM189.147 23.3463L180.662 34.8678L184.447 37.6553H189.147V23.3463ZM27.9596 196.56H206.326V167.942H27.9596V196.56ZM216.945 191.843C223.056 185.077 228.428 177.67 232.932 169.731L208.039 155.611C204.586 161.698 200.447 167.413 195.708 172.66L216.945 191.843ZM220.486 176.98H264.515V148.362H220.486V176.98ZM252.069 169.731C256.572 177.67 261.945 185.077 268.056 191.843L289.293 172.66C284.554 167.413 280.414 161.698 276.961 155.611L252.069 169.731ZM278.675 196.56H457.041V167.942H278.675V196.56ZM467.66 191.843C487.312 170.085 499.31 141.688 499.31 110.562H470.692C470.692 134.143 461.641 155.812 446.422 172.66L467.66 191.843ZM499.31 110.562C499.31 40.8296 439.666 -14.309 367.858 -14.309V14.309C425.442 14.309 470.692 58.1712 470.692 110.562H499.31ZM367.858 -14.309C337.619 -14.309 309.661 -4.59353 287.368 11.8248L304.339 34.8678C321.775 22.0267 343.8 14.309 367.858 14.309V-14.309ZM295.853 9.03726H189.147V37.6553H295.853V9.03726ZM197.633 11.8248C175.34 -4.59354 147.382 -14.309 117.143 -14.309V14.309C141.201 14.309 163.226 22.0267 180.662 34.8678L197.633 11.8248ZM117.143 -14.309C45.3347 -14.309 -14.309 40.8296 -14.309 110.562H14.309C14.309 58.1712 59.5586 14.309 117.143 14.309V-14.309ZM-14.309 110.562C-14.309 141.688 -2.31154 170.085 17.341 191.843L38.5782 172.66C23.3602 155.812 14.309 134.143 14.309 110.562H-14.309Z" fill="#373737" mask="url(#path-1-inside-1_3234_25295)"/>
  <rect opacity="0.6" x="241.1" y="61.7344" width="16.4221" height="16.4221" rx="4.51863" transform="rotate(44 241.1 61.7344)" fill="#CB253D"/>
  <rect opacity="0.6" x="257.637" y="77.7109" width="16.4221" height="16.4221" rx="4.51863" transform="rotate(44 257.637 77.7109)" fill="#145DAD"/>
  <rect opacity="0.6" x="225.129" y="78.2734" width="16.4221" height="16.4221" rx="4.51863" transform="rotate(44 225.129 78.2734)" fill="#145DAD"/>
  <rect opacity="0.6" x="241.666" y="94.25" width="16.4221" height="16.4221" rx="4.51863" transform="rotate(44 241.666 94.25)" fill="#CB253D"/>
</svg>
`

const KEY_CODES = {
  KeyW: 87,  
  KeyA: 65,  
  KeyS: 83,  
  KeyD: 68,  
  ArrowUp: 38,
  ArrowDown: 40,
  ArrowLeft: 37,  
  ArrowRight: 39
} as const;

const KEY_NAMES = {
  87: 'w',
  65: 'a',
  83: 's',
  68: 'd',
  38: 'ArrowUp',
  40: 'ArrowDown',
  37: 'ArrowLeft',
  39: 'ArrowRight'
} as const;

interface GamePadButtonProps {
  keyTrigger: keyof typeof KEY_CODES
  icon: string
  startKeyPress: (key: keyof typeof KEY_CODES) => void
  stopKeyPress: (key: keyof typeof KEY_CODES) => void
  color?: keyof typeof COLORS
  maxSize?: string
  buttonSize: number
}

const GamePadButton: React.FC<GamePadButtonProps> = ({
  keyTrigger,
  icon,
  startKeyPress,
  stopKeyPress,
  color = 'RED',
  maxSize,
  buttonSize,
}) => {
  return (
    <IconButton
      onMouseDown={() => startKeyPress(keyTrigger)}
      onTouchStart={() => startKeyPress(keyTrigger)}
      onTouchEnd={() => stopKeyPress(keyTrigger)}
      onMouseUp={() => stopKeyPress(keyTrigger)}
      style={{ backgroundColor: COLORS[color], border: '3px solid #373737', cursor: 'pointer', width: buttonSize, height: buttonSize, flexShrink: 0, minHeight: "42px", minWidth: "42px" }}
    >
      <img src={icon} alt="test" style={{width: buttonSize * 0.525, height: buttonSize * 0.525, maxHeight: maxSize, maxWidth: maxSize  }} />
    </IconButton>
  )
}

const Gamepad: React.FC = () => {
  const [size,] = React.useState(false);

  const stageWidth = size ? window.innerWidth * 0.35 : window.innerWidth * 0.45;
  const stageHeight = stageWidth * (3 / 4); 
  const gamepadHeight = Math.max(160, window.innerHeight - stageHeight - 220);
  const gamepadWidth = Math.min(gamepadHeight * 3, stageWidth);
  const buttonSize = Math.min(gamepadWidth * 1 / 8, gamepadHeight * 1 / 4);

  const intervalRefs = useRef<Record<string, ReturnType<typeof setInterval>>>({})

  const startKeyPress = (keyType: keyof typeof KEY_CODES) => {
    const keyCode = KEY_CODES[keyType];
    
    // Create and dispatch keydown event with the ASCII code
    const eventDown = new KeyboardEvent('keydown', { 
      key: KEY_NAMES[keyCode as keyof typeof KEY_NAMES],
      keyCode: keyCode,
      which: keyCode,
      code: keyType
    });
    document.dispatchEvent(eventDown);
    
    intervalRefs.current[keyType] = setInterval(() => {
      const eventRepeat = new KeyboardEvent('keydown', { 
        key: KEY_NAMES[keyCode as keyof typeof KEY_NAMES],
        keyCode: keyCode,
        which: keyCode,
        code: keyType,
        repeat: true 
      });
      document.dispatchEvent(eventRepeat);
    }, 100);
  }

  const stopKeyPress = (keyType: keyof typeof KEY_CODES) => {
    const keyCode = KEY_CODES[keyType];
    clearInterval(intervalRefs.current[keyType]);
    
    // Create and dispatch keyup event with the ASCII code
    const eventUp = new KeyboardEvent('keyup', { 
      key: KEY_NAMES[keyCode as keyof typeof KEY_NAMES],
      keyCode: keyCode,
      which: keyCode,
      code: keyType
    });
    document.dispatchEvent(eventUp);
  }
  
  return (
    <Box
      padding="1rem"
      flexShrink="1"
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        minHeight: (isMobile(window.navigator).any) ? '10rem' : '8.5rem',
        backgroundImage: `url('data:image/svg+xml;charset=utf8,${encodeURIComponent(gamepadSVG)}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-around" width="100%" maxWidth={`${gamepadWidth}px`} height="100%" >
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="33%" style={{ aspectRatio: '1/1', marginTop: "10%", gap: '8px'}}>
          <GamePadButton
            keyTrigger="KeyW"
            icon={w}
            startKeyPress={startKeyPress}
            stopKeyPress={stopKeyPress}
            color="RED"
            buttonSize={buttonSize}
          />
          <Box display="flex"
            justifyContent="center"
            flexDirection="row"
            style={{ height: '50%', width: '100%', marginTop: '0', gap: '8px' }}
          >
            <GamePadButton
              keyTrigger="KeyA"
              icon={a}
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              color="RED"
              buttonSize={buttonSize}
            />
            <GamePadButton
              keyTrigger="KeyS"
              icon={s}
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              color="RED"
              buttonSize={buttonSize}
            />
            <GamePadButton
              keyTrigger="KeyD"
              icon={d}
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              color="RED"
              buttonSize={buttonSize}
            />
          </Box>
        </Box>
        <Box />
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="33%" style={{ aspectRatio: '1/1', marginTop: "10%",gap: '8px' }}>
          <GamePadButton
            keyTrigger="ArrowUp"
            icon={upArrow}
            color="BLUE"
            startKeyPress={startKeyPress}
            stopKeyPress={stopKeyPress}
            buttonSize={buttonSize}
          />
          <Box display="flex"
            justifyContent="center"
            flexDirection="row"
            style={{ height: '50%', width: '100%', marginTop: '0', gap: '8px' }}
          >
            <GamePadButton
              keyTrigger="ArrowLeft"
              icon={leftArrow}
              color="BLUE"
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              buttonSize={buttonSize}
            />
            <GamePadButton
              keyTrigger="ArrowDown"
              icon={downArrow}
              color="BLUE"
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              buttonSize={buttonSize}
            />
            <GamePadButton
              keyTrigger="ArrowRight"
              icon={rightArrow}
              color="BLUE"
              startKeyPress={startKeyPress}
              stopKeyPress={stopKeyPress}
              buttonSize={buttonSize}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Gamepad